




























import { Component, Vue } from "vue-property-decorator";
import LaporanMatriksHibrida from "@/components/laporan-kebidanan/LaporanMatriksHibrida.vue";
import LaporanKebidananSvc, {
  LayananMatriksHibrida,
  MatriksHibridaResponse,
  RekapObstetriResponse
} from "@/services/LaporanKebidanan";

@Component({
  components: { LaporanMatriksHibrida },
  beforeRouteLeave(to, from, next) {
    const anak = (this as LaporanRekapObstetriPage).$refs.matriks as unknown as {
      bolehDitinggalkan(): boolean;
    };

    if (anak && !anak.bolehDitinggalkan()) {
      next(false);
      return;
    }

    next();
  }
})
export default class LaporanRekapObstetriPage extends Vue {
  readonly layanan: LayananMatriksHibrida = {
    muat: LaporanKebidananSvc.rekapObstetri,
    simpan: LaporanKebidananSvc.simpanRekapObstetri,
    pdf: LaporanKebidananSvc.pdfRekapObstetri,
    excel: LaporanKebidananSvc.excelRekapObstetri
  };

  adaPeringatan(data: MatriksHibridaResponse): boolean {
    const m = (data as RekapObstetriResponse).meta;

    return (
      m.cara_tidak_tercatat.length > 0 ||
      m.sc_tanpa_indikasi.length > 0 ||
      m.persalinan_ganda.length > 0
    );
  }

  unik(daftar: string[]): string[] {
    return daftar.filter((v, i) => daftar.indexOf(v) === i);
  }
}
